import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const ArrowRight: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M5 12H19M19 12L12 5M19 12L12 19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
